import { render, staticRenderFns } from "./KeywordTextV2.vue?vue&type=template&id=260eb2e4&scoped=true&"
import script from "./KeywordTextV2.vue?vue&type=script&lang=js&"
export * from "./KeywordTextV2.vue?vue&type=script&lang=js&"
import style0 from "./KeywordTextV2.vue?vue&type=style&index=0&id=260eb2e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260eb2e4",
  null
  
)

export default component.exports